export default __webpack_public_path__ + "img/fef243fdb9e5f27603cbb736c51955fc.svg";